import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Startseite' },
    { path: '/ueber-uns', label: 'Über uns' },
    { path: '/projekte', label: 'Projekte' },
    { path: '/strategie', label: 'Strategie & Werte' },
    { path: '/immobilien-verkauf', label: 'Kostenloses Erstgespräch' },
    { path: '/blog', label: 'Blog' },
    { path: '/kontakt', label: 'Kontakt' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/80 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={isScrolled 
                ? "https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/kb7ggkls_LIVAG%20Logo_Schwarz%20Transparent.webp"
                : "https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/8xaolt7j_LIVAG_Logo_2024_Entwickelt%20und%20V.webp"
              }
              alt="LIVAG AG Logo - Nachhaltige Immobilienentwicklung St. Gallen | Haus kaufen und verkaufen Ostschweiz"
              title="LIVAG AG - Ihr Partner für Haus kaufen und verkaufen in St. Gallen"
              width="180"
              height="96"
              className="h-24 w-auto transition-all duration-300"
              fetchPriority="high"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              link.path === '/kontakt' ? (
                <Link
                  key={link.path}
                  to={link.path}
                  className="px-6 py-2 bg-[#264F77] text-white text-sm font-medium rounded-md hover:bg-[#1e3d5c] transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  {link.label}
                </Link>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 ${
                    isScrolled ? 'text-gray-800 hover:text-[#264F77]' : 'text-white hover:text-[#264F77]'
                  } ${
                    location.pathname === link.path
                      ? 'text-[#264F77]'
                      : ''
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? 'Navigation schliessen' : 'Navigation öffnen'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-nav"
            data-testid="mobile-menu-toggle"
            className={`md:hidden p-2 rounded-md transition-colors ${
              isScrolled ? 'text-gray-800 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            {isMobileMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div id="mobile-nav" className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#264F77]'
                    : 'text-gray-800 hover:text-[#264F77]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
